/// <reference path="./next-i18next.config.d.ts" />

const i18nConfig = {
  locales: ["en-US"],
  defaultLocale: "en-US",
  localeDetector: false,
};

module.exports = i18nConfig;
